import {
  Img,
  CheckBox,
  Button,
  Badge,
  BackIcon,
  Actor,
  PreLoader,
  Link,
  Html,
  Input,
  DatePicker,
  Slider,
  Editor,
} from "../element";

const elements: any = {
  Img,
  CheckBox,
  Button,
  Badge,
  BackIcon,
  Actor,
  PreLoader,
  Link,
  Html,
  Input,
  DatePicker,
  Slider,
  Editor,
};

export const useElement = (element: string) => {
  return elements[element];
};
